import gql from 'graphql-tag';

export const smallAd = gql`
    fragment smallAd on ads_sidebarBanner_Entry {
        id
        title
        __typename
        externalLink
        advertisingImage {
            ... on assets_Asset {
                __typename
                id
                kind
                url
                width
                height
                title
                description
            }
        }
    }
`;

export const bigAd = gql`
    fragment bigAd on ads_contentBanner_Entry {
        id
        title
        __typename
        externalLink
        advertisingImage {
            ... on assets_Asset {
                __typename
                id
                kind
                url
                width
                height
                title
                description
            }
        }
    }
`;

export const megaAd = gql`
    fragment megaAd on ads_landingpageBanner_Entry {
        id
        title
        __typename
        externalLink
        advertisingImage {
            ... on assets_Asset {
                __typename
                id
                kind
                url
                width
                height
                title
                description
            }
        }
    }
`;
